import { Toast } from './toast.js';

/**
 * Update page content after status change without reload
 */
const updatePageContent = (newStatus, form) => {
  const newStatusLower = newStatus.toLowerCase();
  const newStatusCapitalized = newStatus.charAt(0).toUpperCase() + newStatus.slice(1).toLowerCase();
  
  // Check if we're on a table page (manager dashboard) or single page
  const row = form.closest('tr');
  
  if (row) {
    // Manager dashboard table update
    updateTableRow(row, newStatusLower, newStatusCapitalized);
  } else {
    // Single vacation request page update
    updateSinglePage(newStatusLower, newStatusCapitalized, form);
  }
};

/**
 * Update table row in manager dashboard
 */
const updateTableRow = (row, newStatusLower, newStatusCapitalized) => {
  // Update status cell (6th column)
  const statusCell = row.querySelector('td:nth-child(6)');
  if (statusCell) {
    statusCell.textContent = newStatusCapitalized;
  }
  
  // Update row classes for styling
  row.classList.remove('status-approved', 'status-rejected', 'status-pending');
  row.classList.add(`status-${newStatusLower}`);
  
  // Hide the form that was just submitted (since action is complete)
  const actionsCell = row.querySelector('td:last-child');
  if (actionsCell) {
    const forms = actionsCell.querySelectorAll('form');
    forms.forEach(form => {
      const statusChange = form.querySelector('input[name="status_change"]').value;
      // Hide the form for the action that was just taken
      if ((newStatusLower === 'approved' && statusChange === 'approve') ||
          (newStatusLower === 'rejected' && statusChange === 'reject')) {
        form.style.display = 'none';
      } else {
        form.style.display = 'inline-block';
      }
    });
  }
};

/**
 * Update single vacation request page
 */
const updateSinglePage = (newStatusLower, newStatusCapitalized, form) => {
  // Update status display
  const statusElements = document.querySelectorAll('.font-light.text-gray-500.dark\\:text-gray-400');
  statusElements.forEach(element => {
    if (element.textContent.match(/^(Pending|Approved|Rejected)$/i)) {
      element.textContent = newStatusCapitalized;
    }
  });
  
  // Update action buttons visibility
  // Find all approve and reject forms on the page
  const allApproveForms = document.querySelectorAll('form[id*="approve-request-form"]');
  const allRejectForms = document.querySelectorAll('form[id*="reject-request-form"]');
  
  if (newStatusLower === 'approved') {
    // If approved: hide approve button, show reject button
    allApproveForms.forEach(form => {
      form.style.display = 'none';
    });
    allRejectForms.forEach(form => {
      form.style.display = 'inline-block';
    });
  } else if (newStatusLower === 'rejected') {
    // If rejected: hide reject button, show approve button
    allRejectForms.forEach(form => {
      form.style.display = 'none';
    });
    allApproveForms.forEach(form => {
      form.style.display = 'inline-block';
    });
  } else {
    // If pending: show both buttons
    allApproveForms.forEach(form => {
      form.style.display = 'inline-block';
    });
    allRejectForms.forEach(form => {
      form.style.display = 'inline-block';
    });
  }
};

export const updateVacationStatus = () => {
  document.querySelectorAll('form.inline-block').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault(); // Prevent default form submission

      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton.innerHTML;
      const statusChange = form.querySelector('input[name="status_change"]').value;
      
      // Update button to show loading state
      submitButton.disabled = true;
      submitButton.innerHTML = '<span class="material-symbols-outlined text-sm animate-spin">sync</span> Processing...';

      const formData = new FormData(form);

      fetch(ajaxurl['ajaxurl'], {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            const actionText = statusChange === 'approve' ? 'approved' : 'rejected';
            const newStatus = data.data.new_status;
            
            Toast.show(`Vacation request ${actionText} successfully!`, 'success');
            
            // Update the page without reload
            updatePageContent(newStatus, form);
            
            // Reset button state
            submitButton.disabled = false;
            submitButton.innerHTML = originalText;
            
          } else {
            Toast.show(data.message || 'An error occurred while updating the status.', 'error');
            
            // Reset button state
            submitButton.disabled = false;
            submitButton.innerHTML = originalText;
          }
        })
        .catch(error => {
          console.error('Error:', error);
          Toast.show('An error occurred while updating the status.', 'error');
          
          // Reset button state
          submitButton.disabled = false;
          submitButton.innerHTML = originalText;
        });
    });
  });
};